// Lightweight EN/ES i18n (PMS pattern). Keys ARE the English strings —
// untranslated keys fall through to English, so new UI never breaks and ES
// coverage grows string by string.
const ES = {
  // login / sso
  'Learning Management System': 'Sistema de Gestión de Aprendizaje',
  'Username or email': 'Usuario o correo',
  Password: 'Contraseña',
  'Sign in': 'Entrar',
  'Signing in…': 'Entrando…',
  'Login failed': 'Error de acceso',
  'Signing you in…': 'Iniciando tu sesión…',
  'SSO sign-in failed': 'Error de acceso por SSO',
  'Missing SSO token': 'Falta el token de SSO',
  'Go to sign in': 'Ir al inicio de sesión',
  'No access to this tool': 'No tienes acceso a esta herramienta',
  admin: 'administrador',
  manager: 'gestor',
  instructor: 'instructor',
  student: 'estudiante',

  // home (Phase 0)
  'Signed in as': 'Sesión iniciada como',
  Role: 'Rol',
  'Sign out': 'Cerrar sesión',
  'Phase 0 — foundation online.': 'Fase 0 — base en línea.',
  'Courses, catalog and player arrive in the next phases.':
    'Los cursos, el catálogo y el reproductor llegan en las próximas fases.',

  // shell (Phase 1)
  Courses: 'Cursos',
  Menu: 'Menú',
  Account: 'Cuenta',
  Purchases: 'Compras',
  'Continue learning': 'Sigue aprendiendo',
  'Jump back into your courses': 'Vuelve a tus cursos',
  'Dark mode': 'Modo oscuro',
  'Light mode': 'Modo claro',
  'Toggle dark mode': 'Alternar modo oscuro',
  Categories: 'Categorías',
  Language: 'Idioma',
  'Loading…': 'Cargando…',
  Save: 'Guardar',
  'Saving…': 'Guardando…',
  Saved: 'Guardado',
  Cancel: 'Cancelar',
  Close: 'Cerrar',
  Delete: 'Eliminar',
  Edit: 'Editar',
  Add: 'Añadir',
  Remove: 'Quitar',
  Rename: 'Renombrar',
  Back: 'Volver',
  Previous: 'Anterior',
  Next: 'Siguiente',
  'Save failed': 'Error al guardar',
  'Delete failed': 'Error al eliminar',
  'Upload failed': 'Error al subir',
  'Reorder failed': 'Error al reordenar',
  'Drag to reorder': 'Arrastra para reordenar',

  // categories
  'New category': 'Nueva categoría',
  'Edit category': 'Editar categoría',
  'No categories yet — create the first one.': 'Aún no hay categorías — crea la primera.',
  'Could not load categories': 'No se pudieron cargar las categorías',
  'Parent (optional — makes it a sub-category)': 'Padre (opcional — la convierte en subcategoría)',
  'None (top level)': 'Ninguno (nivel superior)',
  Thumbnail: 'Miniatura',
  courses: 'cursos',
  Name: 'Nombre',

  // courses list
  'New course': 'Nuevo curso',
  'Search courses…': 'Buscar cursos…',
  'All statuses': 'Todos los estados',
  draft: 'borrador',
  pending: 'pendiente',
  active: 'activo',
  Course: 'Curso',
  Category: 'Categoría',
  Price: 'Precio',
  Status: 'Estado',
  Free: 'Gratis',
  'No courses yet — create the first one.': 'Aún no hay cursos — crea el primero.',
  'Could not load courses': 'No se pudieron cargar los cursos',
  Title: 'Título',
  'You will fill in the rest in the editor.': 'El resto lo completarás en el editor.',
  'Creating…': 'Creando…',
  'Create course': 'Crear curso',

  // course editor
  Details: 'Detalles',
  Curriculum: 'Temario',
  Basics: 'Datos básicos',
  'Could not load the course': 'No se pudo cargar el curso',
  'Short description': 'Descripción corta',
  Description: 'Descripción',
  Level: 'Nivel',
  beginner: 'principiante',
  intermediate: 'intermedio',
  advanced: 'avanzado',
  'Any level': 'Cualquier nivel',
  'Sub-category': 'Subcategoría',
  'What students will learn (outcomes)': 'Lo que aprenderán los estudiantes (resultados)',
  Requirements: 'Requisitos',
  'Add an outcome and press Enter': 'Añade un resultado y pulsa Enter',
  'Add a requirement and press Enter': 'Añade un requisito y pulsa Enter',
  Pricing: 'Precio',
  'Free course': 'Curso gratuito',
  'Price (USD)': 'Precio (USD)',
  'Discount active': 'Descuento activo',
  'Discounted price': 'Precio con descuento',
  Media: 'Medios',
  'No thumbnail': 'Sin miniatura',
  'Upload thumbnail': 'Subir miniatura',
  'Thumbnail updated': 'Miniatura actualizada',
  'Preview video': 'Vídeo de presentación',
  'Preview URL': 'URL de presentación',
  None: 'Ninguno',
  'Publishing & SEO': 'Publicación y SEO',
  'Top course (featured on home)': 'Curso destacado (portada)',
  'Meta keywords': 'Palabras clave (meta)',
  'Meta description': 'Descripción (meta)',
  Tags: 'Etiquetas',
  'Add a tag and press Enter': 'Añade una etiqueta y pulsa Enter',

  // curriculum builder
  'New section': 'Nueva sección',
  'Section title': 'Título de la sección',
  'No sections yet — a course is sections of lessons.': 'Aún no hay secciones — un curso son secciones con lecciones.',
  'Could not load the curriculum': 'No se pudo cargar el temario',
  'Its lessons are deleted too.': 'Sus lecciones también se eliminan.',
  lessons: 'lecciones',
  'No lessons yet.': 'Aún no hay lecciones.',
  'New lesson': 'Nueva lección',
  'Edit lesson': 'Editar lección',
  'Lesson type': 'Tipo de lección',
  'Video (file or direct URL)': 'Vídeo (archivo o URL directa)',
  'External URL': 'URL externa',
  'Embedded page (iframe)': 'Página incrustada (iframe)',
  Document: 'Documento',
  Image: 'Imagen',
  'Video URL (or upload a file below)': 'URL del vídeo (o sube un archivo abajo)',
  URL: 'URL',
  'Upload video file (mp4, 95 MB max)': 'Subir archivo de vídeo (mp4, máx. 95 MB)',
  'Duration (HH:MM:SS)': 'Duración (HH:MM:SS)',
  Duration: 'Duración',
  Autofill: 'Autocompletar',
  'Detecting…': 'Detectando…',
  'Could not detect the duration — enter it manually.': 'No se pudo detectar la duración — introdúcela a mano.',
  'Video uploaded': 'Vídeo subido',
  'File uploaded': 'Archivo subido',
  'Document file': 'Archivo del documento',
  'Image file': 'Archivo de imagen',
  'No file yet': 'Aún sin archivo',
  Upload: 'Subir',
  'Uploading…': 'Subiendo…',
  'Summary (optional)': 'Resumen (opcional)',

  // public storefront (Phase 2)
  Home: 'Inicio',
  'Back-office': 'Administración',
  'View site': 'Ver el sitio',
  'Learn at your own pace.': 'Aprende a tu ritmo.',
  'Courses built by the people who use them every day.':
    'Cursos creados por quienes los usan cada día.',
  'Browse courses': 'Ver los cursos',
  'Top courses': 'Cursos destacados',
  'Latest courses': 'Cursos recientes',
  'See all': 'Ver todos',
  'No published courses yet — check back soon.': 'Aún no hay cursos publicados — vuelve pronto.',
  'All categories': 'Todas las categorías',
  Search: 'Buscar',
  'Explore the full catalog and filter by category, level, and price.':
    'Explora todo el catálogo y filtra por categoría, nivel y precio.',
  'Any price': 'Cualquier precio',
  Paid: 'De pago',
  results: 'resultados',
  'No courses match these filters.': 'Ningún curso coincide con estos filtros.',
  'This course does not exist or is not published.': 'Este curso no existe o no está publicado.',
  'What you will learn': 'Lo que aprenderás',
  'About this course': 'Sobre este curso',
  Reviews: 'Reseñas',
  'Sign in to enroll': 'Inicia sesión para inscribirte',
  'Enrollment opens in a later phase': 'La inscripción se abre en una fase posterior',
  'Full lifetime access': 'Acceso completo de por vida',
  'Learn on any device': 'Aprende en cualquier dispositivo',
  'Instructor not found.': 'Instructor no encontrado.',
  'Page not found.': 'Página no encontrada.',

  // admin frontend settings
  Settings: 'Ajustes',
  'Frontend settings': 'Ajustes del sitio público',
  'Could not load settings': 'No se pudieron cargar los ajustes',
  'Home banner': 'Banner de portada',
  Subtitle: 'Subtítulo',
  'No image': 'Sin imagen',
  'Upload banner image': 'Subir imagen del banner',
  'Image uploaded — remember to Save.': 'Imagen subida — recuerda Guardar.',
  About: 'Acerca de',
  'Terms of use': 'Términos de uso',
  'Privacy policy': 'Política de privacidad',
  'Cookie policy': 'Política de cookies',
  Content: 'Contenido',
  'Leave empty to hide the page from the footer.': 'Déjalo vacío para ocultar la página del pie.',

  // player / progress / quizzes (Phase 3)
  'My courses': 'Mis cursos',
  'You are not enrolled in any course yet.': 'Aún no estás inscrito en ningún curso.',
  complete: 'completado',
  Continue: 'Continuar',
  Start: 'Empezar',
  'Go to course': 'Ir al curso',
  Progress: 'Progreso',
  'Mark complete': 'Marcar como completada',
  'Complete the previous lessons first.': 'Completa las lecciones anteriores primero.',
  'Complete this lesson to continue.': 'Completa esta lección para continuar.',
  'Completed — undo': 'Completada — deshacer',
  'You are not enrolled in this course.': 'No estás inscrito en este curso.',
  'View the course page': 'Ver la página del curso',
  'Course not found': 'Curso no encontrado',
  'This course has no lessons yet.': 'Este curso aún no tiene lecciones.',
  'Open resource': 'Abrir el recurso',
  'Open document': 'Abrir el documento',
  'Invalid video URL.': 'URL de vídeo no válida.',
  'Submit answers': 'Enviar respuestas',
  'Submitting…': 'Enviando…',
  'Your score': 'Tu puntuación',
  'Retake quiz': 'Repetir el cuestionario',
  Correct: 'Correcta',
  Incorrect: 'Incorrecta',
  answer: 'respuesta',
  'Last attempt': 'Último intento',

  // quiz builder
  Quiz: 'Cuestionario',
  Questions: 'Preguntas',
  Question: 'Pregunta',
  Option: 'Opción',
  'Add option': 'Añadir opción',
  'Add question': 'Añadir pregunta',
  'Correct answer': 'Respuesta correcta',
  'Tick the checkbox beside each correct option (one or more).':
    'Marca la casilla junto a cada opción correcta (una o más).',

  // enrollments admin
  Enrollments: 'Inscripciones',
  'Could not load enrollments': 'No se pudieron cargar las inscripciones',
  'Enroll a member': 'Inscribir a un miembro',
  Enroll: 'Inscribir',
  Enrolled: 'Inscrito',
  Member: 'Miembro',
  'Search…': 'Buscar…',
  'Search members…': 'Buscar miembros…',
  'No matches': 'Sin coincidencias',
  Change: 'Cambiar',
  'No enrollments yet.': 'Aún no hay inscripciones.',
  'Remove enrollment for': 'Quitar la inscripción de',
  purchase: 'compra',
  free: 'gratuita',
  import: 'importada',

  // shop / payments (Phase 4)
  Cart: 'Carrito',
  'Your cart is empty.': 'Tu carrito está vacío.',
  Total: 'Total',
  'Checkout with Stripe': 'Pagar con Stripe',
  'Redirecting…': 'Redirigiendo…',
  'Checkout failed': 'Error en el pago',
  'Payment is handled on Stripe’s secure page — card details never touch this site.':
    'El pago se realiza en la página segura de Stripe — los datos de tarjeta nunca pasan por este sitio.',
  'Missing checkout session.': 'Falta la sesión de pago.',
  'Could not confirm the payment.': 'No se pudo confirmar el pago.',
  'Confirming your payment…': 'Confirmando tu pago…',
  'You are enrolled!': '¡Ya estás inscrito!',
  'Payment confirmed — your courses are ready.': 'Pago confirmado — tus cursos están listos.',
  'Back to cart': 'Volver al carrito',
  'View purchase history': 'Ver el historial de compras',
  'Purchase history': 'Historial de compras',
  'No purchases yet.': 'Aún no hay compras.',
  Amount: 'Importe',
  Date: 'Fecha',
  Invoice: 'Factura',
  'Invoice not found.': 'Factura no encontrada.',
  'Billed to': 'Facturado a',
  Item: 'Concepto',
  Print: 'Imprimir',
  'Paid via': 'Pagado con',
  Reference: 'Referencia',
  Wishlist: 'Lista de deseos',
  'Nothing saved yet.': 'Aún no has guardado nada.',
  'Remove from wishlist': 'Quitar de la lista de deseos',
  'In your wishlist': 'En tu lista de deseos',
  'Add to wishlist': 'Añadir a la lista de deseos',
  'Enroll for free': 'Inscribirse gratis',
  // s137 clear lesson content
  'Preview page': 'Vista previa de la página',
  'The course page as students will see it': 'La página del curso tal como la verán los alumnos',
  'Preview as student': 'Vista previa como alumno',
  'Take the course as a student: lessons, progress, checks': 'Recorre el curso como alumno: lecciones, avance, pruebas',
  'students can’t see this course yet.': 'los alumnos aún no pueden ver este curso.',
  Unpublished: 'No publicado',
  'Reset your preview progress? Every lesson goes back to not completed.': '¿Reiniciar tu progreso de vista previa? Todas las lecciones vuelven a no completadas.',
  'Preview progress reset': 'Progreso de vista previa reiniciado',
  'Preview mode': 'Modo vista previa',
  'you see the course as a student; your progress here is only a test.': 'ves el curso como un alumno; tu progreso aquí es solo de prueba.',
  'Reset my preview progress': 'Reiniciar mi progreso de prueba',
  'Preview this lesson as a student': 'Ver esta lección como alumno',
  'Open file': 'Abrir archivo',
  Hide: 'Ocultar',
  Show: 'Mostrar',
  'This file type can’t be shown here — open it to check it.': 'Este tipo de archivo no se puede mostrar aquí; ábrelo para revisarlo.',
  'Delete all questions': 'Eliminar todas las preguntas',
  'No questions — the check is off. Save the lesson to apply.': 'Sin preguntas: la prueba queda desactivada. Guarda la lección para aplicarlo.',
  'Clear content…': 'Limpiar contenido…',
  'Clear lesson content': 'Limpiar contenido de la lección',
  'stays in the course with its title, type and position. Choose what to remove:': 'se mantiene en el curso con su título, tipo y posición. Elige qué quitar:',
  'The video (URL or uploaded file)': 'El video (URL o archivo subido)',
  'The YouTube link': 'El enlace de YouTube',
  'The Vimeo link': 'El enlace de Vimeo',
  'The external link': 'El enlace externo',
  'The embedded page URL': 'La URL de la página incrustada',
  'The document file': 'El archivo del documento',
  'The image file': 'El archivo de imagen',
  'The HTML page': 'La página HTML',
  'All quiz questions': 'Todas las preguntas del quiz',
  'The lesson material': 'El material de la lección',
  'Students will see “No content yet” until you add new material.': 'Los alumnos verán “Sin contenido aún” hasta que añadas material nuevo.',
  'Nothing to remove.': 'No hay nada que quitar.',
  'The lesson text (summary)': 'El texto de la lección (resumen)',
  'The written text shown under the lesson.': 'El texto que se muestra bajo la lección.',
  'The comprehension check': 'Las preguntas de comprensión',
  'past attempts are kept in the results.': 'los intentos anteriores se conservan en los resultados.',
  'This cannot be undone. Uploaded files are unlinked from the lesson, not deleted from the server.': 'No se puede deshacer. Los archivos subidos se desvinculan de la lección, no se borran del servidor.',
  'Clearing…': 'Limpiando…',
  'Clear selected': 'Limpiar lo seleccionado',
  'Lesson content cleared': 'Contenido de la lección limpiado',
  Empty: 'Vacía',
  'This lesson has no content yet': 'Esta lección aún no tiene contenido',
  'No content yet': 'Sin contenido aún',
  'The material for this lesson is being prepared. Check back soon.': 'El material de esta lección se está preparando. Vuelve pronto.',
  // s136 course discounts + coupons
  'Used in the sidebar, the lesson player and the browser tab. Leave empty to show only the logo.': 'Se usa en la barra lateral, el reproductor de lecciones y la pestaña del navegador. Déjalo vacío para mostrar solo el logo.',
  '(logo only — no logo set in the CMS)': '(solo logo; no hay logo configurado en el CMS)',
  'e.g.': 'p. ej.',
  'Payment cancelled — your coupon is available again.': 'Pago cancelado: tu cupón vuelve a estar disponible.',
  'Coupon released': 'Cupón liberado',
  Release: 'Liberar',
  'checkout opened, not paid yet': 'pago iniciado, aún sin pagar',
  'Checkout opened by': 'Pago iniciado por',
  'not paid yet': 'aún sin pagar',
  'Discount type': 'Tipo de descuento',
  'Fixed amount ($)': 'Monto fijo ($)',
  'Percentage (%)': 'Porcentaje (%)',
  'Discount (%)': 'Descuento (%)',
  'Discount (USD)': 'Descuento (USD)',
  'Final price': 'Precio final',
  'Enter a percentage between 1 and 100.': 'Ingresa un porcentaje entre 1 y 100.',
  'Enter an amount greater than 0 and not above the price.': 'Ingresa un monto mayor que 0 y no mayor que el precio.',
  Coupons: 'Cupones',
  'Single-use percentage coupons. Each code works once, and you can see who used it.': 'Cupones de porcentaje de un solo uso. Cada código funciona una vez y puedes ver quién lo usó.',
  'Create coupon': 'Crear cupón',
  'In checkout': 'En pago',
  'held while paying': 'retenido mientras paga',
  Used: 'Usado',
  'Used by': 'Usado por',
  'Search code, member or CA-…': 'Buscar código, miembro o CA-…',
  'No coupons match these filters.': 'Ningún cupón coincide con estos filtros.',
  'No coupons yet.': 'Aún no hay cupones.',
  'Could not load coupons': 'No se pudieron cargar los cupones',
  'Coupon created': 'Cupón creado',
  'Delete coupon': 'Eliminar cupón',
  'Copy code': 'Copiar código',
  'Could not copy': 'No se pudo copiar',
  used: 'usado',
  created: 'creado',
  Code: 'Código',
  Discount: 'Descuento',
  'Code (optional)': 'Código (opcional)',
  'Leave empty to generate one': 'Déjalo vacío para generarlo',
  'Note (optional)': 'Nota (opcional)',
  'e.g. who it is for': 'p. ej. para quién es',
  'The coupon can be used once, on any paid course. 100% makes the order free.': 'El cupón se puede usar una sola vez, en cualquier curso de pago. Con 100 % la compra es gratis.',
  'Have a coupon?': '¿Tienes un cupón?',
  'Coupon code': 'Código de cupón',
  Apply: 'Aplicar',
  'Remove coupon': 'Quitar cupón',
  'Could not apply the coupon': 'No se pudo aplicar el cupón',
  'You save': 'Ahorras',
  'Enroll now': 'Inscribirme ahora',
  'This coupon code does not exist': 'Este código de cupón no existe',
  'This coupon has already been used': 'Este cupón ya fue usado',
  'This coupon is being used in another checkout': 'Este cupón se está usando en otro pago',
  'This coupon is no longer available': 'Este cupón ya no está disponible',
  // s135 access workflow (register → approval → manual lesson release)
  Register: 'Registrarse',
  'Sign in to register': 'Inicia sesión para registrarte',
  'Registration pending': 'Registro pendiente',
  'Your request was sent. You will get an email once it is approved.': 'Tu solicitud fue enviada. Recibirás un correo cuando sea aprobada.',
  'Registration sent. You will get an email once it is approved.': 'Registro enviado. Recibirás un correo cuando sea aprobado.',
  'Pending approval': 'Pendiente de aprobación',
  'Next lesson coming soon': 'Próxima lección en camino',
  'Well done — your next lesson is on its way': 'Bien hecho: tu próxima lección está en camino',
  'This is your latest lesson': 'Esta es tu lección más reciente',
  'Your mentor releases each lesson personally. You will get an email as soon as the next one is available.': 'Tu mentor libera cada lección personalmente. Recibirás un correo en cuanto la siguiente esté disponible.',
  'Complete it and your mentor will release the next lesson. You will get an email when it is available.': 'Complétala y tu mentor liberará la siguiente lección. Recibirás un correo cuando esté disponible.',
  'Awaiting release': 'Esperando liberación',
  'Release next': 'Liberar siguiente',
  'All released': 'Todo liberado',
  'Lessons released': 'Lecciones liberadas',
  'Registration approved': 'Registro aprobado',
  'Registration rejected': 'Registro rechazado',
  'Lesson released': 'Lección liberada',
  'Reject the registration of': 'Rechazar el registro de',
  Registration: 'Registro',
  'All sources': 'Todos los orígenes',
  'Enrolling…': 'Inscribiendo…',
  'Buy now': 'Comprar ahora',
  'Add to cart': 'Añadir al carrito',
  'Added to cart': 'Añadido al carrito',
  Payments: 'Pagos',
  'Payments & revenue': 'Pagos e ingresos',
  'Could not load payments': 'No se pudieron cargar los pagos',
  'Gross revenue': 'Ingresos brutos',
  'Platform share': 'Parte de la plataforma',
  'Instructor share': 'Parte del instructor',
  Sales: 'Ventas',
  'Top courses by revenue': 'Cursos con más ingresos',
  'Split (platform / instructor)': 'Reparto (plataforma / instructor)',
  'No payments recorded yet.': 'Aún no hay pagos registrados.',

  // instructor marketplace (Phase 5)
  'Become an instructor': 'Conviértete en instructor',
  'Teach on this platform and earn a share of every sale.':
    'Enseña en esta plataforma y gana una parte de cada venta.',
  'Application status': 'Estado de la solicitud',
  'Your application is being reviewed.': 'Tu solicitud está en revisión.',
  'Approved! Sign in again to open your instructor dashboard.':
    '¡Aprobada! Vuelve a iniciar sesión para abrir tu panel de instructor.',
  'Your last application was not approved — you may apply again.':
    'Tu última solicitud no fue aprobada — puedes volver a solicitarlo.',
  'Instructor applications are closed right now.': 'Las solicitudes de instructor están cerradas por ahora.',
  'You already have author access.': 'Ya tienes acceso de autor.',
  'Open the back-office': 'Abrir la administración',
  Phone: 'Teléfono',
  Address: 'Dirección',
  'Tell us about what you would teach': 'Cuéntanos qué enseñarías',
  'Supporting document (CV, portfolio — optional)': 'Documento de apoyo (CV, portafolio — opcional)',
  'Submit application': 'Enviar la solicitud',
  'Application submitted': 'Solicitud enviada',
  approved: 'aprobada',
  rejected: 'rechazada',
  'Set to "pending" to submit for review — staff publish it.':
    'Ponlo en "pendiente" para enviarlo a revisión — el personal lo publica.',
  Earnings: 'Ganancias',
  'Total earned': 'Total ganado',
  'Withdrawn / pending': 'Retirado / pendiente',
  Available: 'Disponible',
  'Request withdrawal': 'Solicitar retiro',
  'Withdrawal requested': 'Retiro solicitado',
  Withdrawals: 'Retiros',
  'No withdrawal requests yet.': 'Aún no hay solicitudes de retiro.',
  'No sales yet.': 'Aún no hay ventas.',
  'Sale amount': 'Importe de la venta',
  'Your share': 'Tu parte',
  'Payout method / details': 'Método / datos de pago',
  'e.g. bank transfer, PayPal email — how you want to be paid.':
    'p. ej. transferencia bancaria, correo de PayPal — cómo quieres cobrar.',
  Request: 'Solicitar',
  paid: 'pagado',
  'Instructor applications': 'Solicitudes de instructor',
  'Could not load applications': 'No se pudieron cargar las solicitudes',
  'Nothing here.': 'No hay nada aquí.',
  'no phone': 'sin teléfono',
  Document: 'Documento',
  Approve: 'Aprobar',
  Reject: 'Rechazar',
  'Approved — instructor role granted.': 'Aprobada — rol de instructor concedido.',
  Rejected: 'Rechazada',
  'Payout requests': 'Solicitudes de pago',
  'Could not load payouts': 'No se pudieron cargar los pagos',
  Instructor: 'Instructor',
  Method: 'Método',
  Requested: 'Solicitado',
  Pay: 'Pagar',
  'Mark as PAID': 'Marcar como PAGADO',
  '(pay them first by the requested method)': '(págale primero por el método solicitado)',
  'Marked as paid': 'Marcado como pagado',
  Applications: 'Solicitudes',
  Payouts: 'Pagos a instructores',

  // engagement (Phase 6)
  Notifications: 'Notificaciones',
  'Nothing yet.': 'Aún no hay nada.',
  Messages: 'Mensajes',
  'No conversations yet — message an instructor from a course page.':
    'Aún no hay conversaciones — escribe a un instructor desde la página de un curso.',
  'Pick a conversation.': 'Elige una conversación.',
  'Could not load the conversation': 'No se pudo cargar la conversación',
  'Write a message…': 'Escribe un mensaje…',
  Send: 'Enviar',
  'Sending…': 'Enviando…',
  'Rate this course': 'Valora este curso',
  'Your review (optional)': 'Tu reseña (opcional)',
  'Submit review': 'Enviar la reseña',
  'Thanks for your review!': '¡Gracias por tu reseña!',
  'Message the instructor': 'Escribir al instructor',
  Message: 'Mensaje a',
  'Your message': 'Tu mensaje',
  // mentor calendar (LMS slots of the assigned mentor)
  "Mentor calendar": "Calendario del mentor",
  "Could not load the mentor calendar": "No se pudo cargar el calendario del mentor",
  "Book a session with your mentor": "Reserva una sesión con tu mentor",
  "to clear up any doubt about your courses.": "para resolver cualquier duda sobre tus cursos.",
  "Book a session with your mentor to clear up any doubt about your courses.": "Reserva una sesión con tu mentor para resolver cualquier duda sobre tus cursos.",
  "You don't have an assigned mentor yet. Once one is assigned, their available sessions will appear here.": "Aún no tienes un mentor asignado. Cuando se te asigne uno, aquí aparecerán sus sesiones disponibles.",
  "Your booking will reference this lesson": "Tu reserva hará referencia a esta lección",
  "The lesson you were studying": "La lección que estabas estudiando",
  "Your membership level does not include booking mentor sessions. You can still see the available times.": "Tu nivel de membresía no incluye reservar sesiones con el mentor. Aún puedes ver los horarios disponibles.",
  "My sessions": "Mis sesiones",
  "Available sessions": "Sesiones disponibles",
  "Your mentor has no sessions open for course questions right now. Check back soon.": "Tu mentor no tiene sesiones abiertas para dudas de cursos en este momento. Vuelve pronto.",
  "Past sessions": "Sesiones anteriores",
  "Book a session": "Reservar una sesión",
  "What would you like to go over?": "¿Qué te gustaría revisar?",
  "Optional — helps your mentor prepare.": "Opcional: ayuda a tu mentor a prepararse.",
  "e.g. I did not understand the second example of this lesson…": "p. ej. No entendí el segundo ejemplo de esta lección…",
  "One session credit will be used.": "Se usará un crédito de sesión.",
  "Booking…": "Reservando…",
  "Join waiting list": "Unirme a la lista de espera",
  "Confirm booking": "Confirmar reserva",
  "Session booked": "Sesión reservada",
  "Added to the waiting list": "Añadido a la lista de espera",
  "Booking failed": "No se pudo reservar",
  "Cancel this booking?": "¿Cancelar esta reserva?",
  "Booking cancelled": "Reserva cancelada",
  "Could not cancel": "No se pudo cancelar",
  "Booked": "Reservado",
  "On the waiting list": "En lista de espera",
  "Leave": "Salir",
  "Pay & book in My Account": "Pagar y reservar en Mi Cuenta",
  "Book with 1 credit": "Reservar con 1 crédito",
  "Book this session": "Reservar esta sesión",
  "Full": "Completo",
  "spots left": "plazas libres",
  "Join the session": "Entrar a la sesión",
  "Join": "Entrar",
  "Upcoming": "Próxima",
  "Completed": "Completada",
  "Waiting list": "Lista de espera",
  "Cancelled": "Cancelada",
  "Questions about this lesson?": "¿Dudas con esta lección?",
  "Book a session with your mentor to go over it.": "Reserva una sesión con tu mentor para revisarla.",
  // s134 redesign (home / course page / my learning / player)
  'Added to your wishlist': 'Añadido a tu lista de deseos',
  'Removed from your wishlist': 'Quitado de tu lista de deseos',
  'Course options': 'Opciones del curso',
  'Add to / remove from wishlist': 'Añadir o quitar de deseos',
  'All courses': 'Todos los cursos',
  'Most relevant': 'Más relevantes',
  'Newest': 'Más recientes',
  'Oldest': 'Más antiguos',
  'Title A–Z': 'Título A–Z',
  'Sort by': 'Ordenar por',
  'Clear filters': 'Quitar filtros',
  'course': 'curso',
  'My learning': 'Mi aprendizaje',
  'Course details': 'Detalles del curso',
  'Start course': 'Empezar curso',
  'Your rating': 'Tu valoración',
  'Leave a rating': 'Deja una valoración',
  'Recently accessed': 'Vistos recientemente',
  'Recently enrolled': 'Inscritos recientemente',
  'lesson': 'lección',
  'section': 'sección',
  'sections': 'secciones',
  'Locked': 'Bloqueada',
  'video lesson': 'lección en vídeo',
  'video lessons': 'lecciones en vídeo',
  'document': 'documento',
  'documents': 'documentos',
  'quiz': 'cuestionario',
  'quizzes': 'cuestionarios',
  'Wealth Baseline Scorecard': 'Wealth Baseline Scorecard',
  'Sessions with your mentor': 'Sesiones con tu mentor',
  'Book sessions with your mentor': 'Reserva sesiones con tu mentor',
  'Open the course': 'Abrir el curso',
  'Share': 'Compartir',
  'Link copied': 'Enlace copiado',
  'Breadcrumb': 'Ruta',
  'rating': 'valoración',
  'ratings': 'valoraciones',
  'Created by': 'Creado por',
  'Last updated': 'Última actualización',
  'language': 'idioma',
  "What you'll learn": 'Lo que aprenderás',
  'Related topics': 'Temas relacionados',
  'This course includes:': 'Este curso incluye:',
  'Course content': 'Contenido del curso',
  'Collapse all sections': 'Contraer todas las secciones',
  'Expand all sections': 'Ampliar todas las secciones',
  'Show more': 'Ver más',
  'Show less': 'Ver menos',
  'Close course content': 'Cerrar el contenido del curso',
  'Complete lesson': 'Completa la lección',
  'to unlock': 'para desbloquear',
  'now playing': 'en curso',
  'Book a session with your mentor to go over it. Your booking will reference this lesson so your mentor comes prepared.': 'Reserva una sesión con tu mentor para revisarla. Tu reserva hará referencia a esta lección para que tu mentor llegue preparado.',
  'See my sessions': 'Ver mis sesiones',
  'Your progress': 'Tu progreso',
  'Overview': 'Descripción general',
  'Mentor sessions': 'Sesiones con el mentor',
  'of': 'de',
  'Lesson': 'Lección',
  'Type': 'Tipo',
  'Mark this lesson complete to unlock the next one.': 'Marca esta lección como completada para desbloquear la siguiente.',
  'How is this course going?': '¿Qué tal va el curso?',
  'Your rating helps other members choose — and helps the instructor improve.': 'Tu valoración ayuda a otros miembros a elegir y al instructor a mejorar.',
  'See all reviews': 'Ver todas las reseñas',
  'Video': 'Vídeo',
  'Link': 'Enlace',
  'Embed': 'Contenido incrustado',
  'Scorecard': 'Scorecard',
  // s134 admin redesign
  'Actions': 'Acciones',
  'Active': 'Activo',
  'Active courses are visible in the catalog.': 'Los cursos activos se ven en el catálogo.',
  'Add a learning outcome…': 'Añade un resultado de aprendizaje…',
  'Add a requirement…': 'Añade un requisito…',
  'Add image': 'Añadir imagen',
  'Add lesson': 'Añadir lección',
  'Add sub-category': 'Añadir subcategoría',
  'Admin': 'Admin',
  'All': 'Todos',
  'All changes saved': 'Todos los cambios guardados',
  'All time': 'Desde siempre',
  'Approve as instructor': 'Aprobar como instructor',
  'Approved': 'Aprobadas',
  'Available balance': 'Saldo disponible',
  'Average progress': 'Progreso medio',
  'Background image': 'Imagen de fondo',
  'Catalog': 'Catálogo',
  'Category created': 'Categoría creada',
  'Category created, but the image upload failed': 'Categoría creada, pero la imagen no se pudo subir',
  'Change image': 'Cambiar imagen',
  'Close menu': 'Cerrar menú',
  'Collapse all': 'Contraer todo',
  'Course URL': 'URL del curso',
  'Create': 'Crear',
  'Create category': 'Crear categoría',
  'Create the first one with the form on the right.': 'Crea la primera con el formulario de la derecha.',
  'Create your first course to start building its curriculum.': 'Crea tu primer curso para empezar a construir su temario.',
  'Create, edit and publish the courses of your academy.': 'Crea, edita y publica los cursos de tu academia.',
  'Delete lesson': 'Eliminar lección',
  'Delete section': 'Eliminar sección',
  'Done': 'Listo',
  'Draft': 'Borrador',
  'Each sale of one of your courses shows up here with your share.': 'Cada venta de uno de tus cursos aparece aquí con tu parte.',
  'Edit course': 'Editar curso',
  'Empty pages are hidden from the footer': 'Las páginas vacías no se muestran en el pie',
  'Every purchase of a paid course lands here with its platform / instructor split.': 'Cada compra de un curso de pago aparece aquí con su reparto plataforma / instructor.',
  'Expand all': 'Ampliar todo',
  'Featured in “Top courses” on the home.': 'Destacado en “Cursos destacados” de la portada.',
  'Footer pages': 'Páginas del pie',
  'Generated from the name.': 'Se genera a partir del nombre.',
  'Hidden': 'Oculta',
  'How payouts work': 'Cómo funcionan los pagos',
  'In footer': 'En el pie',
  'Instructor requests to withdraw their share of course sales.': 'Solicitudes de los instructores para retirar su parte de las ventas.',
  'Instructor share owed': 'Pendiente con instructores',
  'Instructors request a payout from their Earnings page once they have an available balance.': 'Los instructores piden un pago desde su página de Ganancias cuando tienen saldo disponible.',
  'JPG or PNG · 1600 × 900 recommended': 'JPG o PNG · recomendado 1600 × 900',
  'Last 30 days': 'Últimos 30 días',
  'Lessons': 'Lecciones',
  'Live preview': 'Vista previa',
  'Mark as paid': 'Marcar como pagado',
  'Mark as top': 'Marcar como destacado',
  'Members apply from “Become an instructor” in the LMS footer. Approving one grants the instructor role so they can create their own courses.': 'Los miembros lo solicitan desde “Hazte instructor” en el pie del LMS. Al aprobar, reciben el rol de instructor y pueden crear sus propios cursos.',
  'Members who asked to teach on the platform.': 'Miembros que pidieron enseñar en la plataforma.',
  'More actions': 'Más acciones',
  'No applicants match your search.': 'Ningún solicitante coincide con tu búsqueda.',
  'No approved applications': 'No hay solicitudes aprobadas',
  'No categories yet': 'Aún no hay categorías',
  'No category': 'Sin categoría',
  'No content': 'Sin contenido',
  'No courses yet': 'Aún no hay cursos',
  'No document attached': 'Sin documento adjunto',
  'No enrollments match these filters.': 'Ninguna inscripción coincide con estos filtros.',
  'No instructors match your search.': 'Ningún instructor coincide con tu búsqueda.',
  'No payments match your search.': 'Ningún pago coincide con tu búsqueda.',
  'No payments yet': 'Aún no hay pagos',
  'No payouts paid yet': 'Aún no hay pagos realizados',
  'No pending applications': 'No hay solicitudes pendientes',
  'No pending payout requests': 'No hay solicitudes de pago pendientes',
  'No rejected applications': 'No hay solicitudes rechazadas',
  'No rejected payouts': 'No hay pagos rechazados',
  'Nothing to rank yet — shows once the first sale comes in.': 'Aún no hay nada que ordenar: aparece con la primera venta.',
  'Organization': 'Organización',
  'Paid courses on sale:': 'Cursos de pago a la venta:',
  'Paid out': 'Pagado',
  'Parent': 'Categoría padre',
  'Pending': 'Pendiente',
  'Pending requests': 'Solicitudes pendientes',
  'Pending review': 'En revisión',
  'Pick a parent to make it a sub-category.': 'Elige una categoría padre para que sea subcategoría.',
  'Platform': 'Plataforma',
  'Published': 'Publicados',
  'Publishing': 'Publicación',
  'Purchase': 'Compra',
  'Remove from top': 'Quitar de destacados',
  'Rename section': 'Renombrar sección',
  'Replace': 'Reemplazar',
  'Replace thumbnail': 'Reemplazar miniatura',
  'Request a withdrawal of your available balance and say how you want to be paid.': 'Pide un retiro de tu saldo disponible e indica cómo quieres cobrar.',
  'SEO & tags': 'SEO y etiquetas',
  'Sales of paid courses and how each one is split between the platform and the instructor.': 'Ventas de cursos de pago y cómo se reparte cada una entre la plataforma y el instructor.',
  'Save changes': 'Guardar cambios',
  'Search applicant…': 'Buscar solicitante…',
  'Search instructor…': 'Buscar instructor…',
  'Search member or course…': 'Buscar miembro o curso…',
  'Search member or email…': 'Buscar miembro o email…',
  'Send the money by the requested method first — “Mark as paid” only records it.': 'Primero envía el dinero por el método solicitado: “Marcar como pagado” solo lo registra.',
  'Set to "Pending" to submit for review — staff publish it.': 'Pon "Pendiente" para enviarlo a revisión: el equipo lo publica.',
  'Shown on course cards and under the title': 'Se muestra en las tarjetas y bajo el título',
  'Solid brand colour': 'Color sólido de la marca',
  'Source': 'Origen',
  'Split · platform / instructor': 'Reparto · plataforma / instructor',
  'Storefront': 'Tienda',
  'Students': 'Alumnos',
  'Students & sales': 'Alumnos y ventas',
  'Teaching': 'Enseñanza',
  'The admin sends the money by that method.': 'El administrador envía el dinero por ese método.',
  'The request is marked Paid and leaves your balance.': 'La solicitud se marca como pagada y sale de tu saldo.',
  'This year': 'Este año',
  'Top': 'Destacado',
  'Top course': 'Curso destacado',
  'Turn off to set a price and an optional discount.': 'Desactívalo para poner precio y un descuento opcional.',
  'Unenroll': 'Dar de baja',
  'Unsaved changes': 'Cambios sin guardar',
  'Updated': 'Actualizado',
  'Upload a square image': 'Sube una imagen cuadrada',
  'Very short — add the full text': 'Muy corta: añade el texto completo',
  'View attached document': 'Ver documento adjunto',
  'View course': 'Ver curso',
  'View in site': 'Ver en el sitio',
  'What students see on the LMS storefront.': 'Lo que ven los alumnos en la tienda del LMS.',
  'What students will learn': 'Lo que aprenderán los alumnos',
  'Who is taking which course, how far they are, and how they got in.': 'Quién hace cada curso, cuánto lleva y cómo entró.',
  'Wide image · 1600 × 400 or larger': 'Imagen ancha · 1600 × 400 o mayor',
  'Your share of every sale of your courses.': 'Tu parte de cada venta de tus cursos.',
  'all time': 'desde siempre',
  'categories': 'categorías',
  'category': 'categoría',
  'characters': 'caracteres',
  'courses at 100%': 'cursos al 100 %',
  'drag sections and lessons to reorder': 'arrastra secciones y lecciones para reordenar',
  'drag to reorder': 'arrastra para reordenar',
  'drag to set the order of the pills on the home.': 'arrastra para fijar el orden de las píldoras de la portada.',
  'e.g. Real Estate': 'p. ej. Bienes raíces',
  'from Payments': 'según Pagos',
  'items': 'elementos',
  'owed via Payouts': 'a pagar vía Pagos a instructores',
  'paid out or requested': 'pagado o solicitado',
  'ready to withdraw': 'listo para retirar',
  'request': 'solicitud',
  'requests': 'solicitudes',
  'sale': 'venta',
  'sales': 'ventas',
  'students': 'alumnos',
  'sub-categories': 'subcategorías',
  'sub-category': 'subcategoría',
  'unique members': 'miembros únicos',
  'was': 'antes',
  'your share of all sales': 'tu parte de todas las ventas',
  'Administrator': 'Administrador',
  'Manager': 'Gestor',
  'Course editor': 'Editor de curso',
  // s134 branding
  'Branding': 'Marca',
  'Name shown next to the logo': 'Nombre junto al logo',
  'Used in the sidebar, the lesson player and the browser tab. Leave empty to use': 'Se usa en el menú lateral, el reproductor de lecciones y la pestaña del navegador. Déjalo vacío para usar',
  'The logo comes from the main CMS: Settings → the logo for dark backgrounds.': 'El logo viene del CMS principal: Ajustes → el logo para fondos oscuros.',
  // s134 html lessons + comprehension check
  '(no text yet)': '(aún sin texto)',
  'Answer all questions (no minimum)': 'Responder todas (sin mínimo)',
  'Answer them all to complete it': 'Respóndelas todas para completarla',
  'Answers': 'Respuestas',
  'Ask these questions before the lesson can be completed': 'Hacer estas preguntas antes de poder completar la lección',
  'Attempts': 'Intentos',
  'Back to results': 'Volver al resultado',
  'Check results': 'Resultados de las preguntas',
  'Check your understanding': 'Comprueba lo que aprendiste',
  'Checking…': 'Comprobando…',
  'Choose an .html file': 'Elige un archivo .html',
  'Collapse preview': 'Contraer vista previa',
  'Comprehension check': 'Preguntas de validación',
  'Could not check your answer': 'No se pudo comprobar tu respuesta',
  'Could not load the results': 'No se pudieron cargar los resultados',
  'Could not load this lesson.': 'No se pudo cargar esta lección.',
  'Could not open the scorecard': 'No se pudo abrir el scorecard',
  'Delete question': 'Eliminar pregunta',
  'Fit to content': 'Ajustar al contenido',
  'Fixed height': 'Altura fija',
  'For apps or slides that scroll inside themselves.': 'Para apps o presentaciones con scroll propio.',
  'Full screen': 'Pantalla completa',
  'Get': 'Acierta',
  'Grows with the page, no inner scroll. Recommended.': 'Crece con la página, sin scroll interno. Recomendado.',
  'HTML code': 'Código HTML',
  'HTML page': 'Página HTML',
  'Height': 'Altura',
  'Height on the lesson page': 'Altura en la página de la lección',
  'Hide the HTML format': 'Ocultar el formato HTML',
  'If they don’t pass': 'Si no aprueban',
  'Images and fonts must use full https:// links. Scripts run isolated — they can’t read the student’s session.': 'Las imágenes y fuentes deben usar enlaces https:// completos. Los scripts se ejecutan aislados: no pueden leer la sesión del alumno.',
  'Interactive lesson': 'Lección interactiva',
  'Lesson complete': 'Lección completada',
  'Lesson editor': 'Editor de lección',
  'Load questions from HTML': 'Cargar preguntas desde HTML',
  'Mark correct': 'Marcar como correcta',
  'Missed per question': 'Fallos por pregunta',
  'Next lesson': 'Siguiente lección',
  'Next question': 'Siguiente pregunta',
  'Nice work — you have finished this lesson.': 'Buen trabajo: has terminado esta lección.',
  'Nice work. Lesson': 'Buen trabajo. La lección',
  'No questions found — check the HTML format.': 'No se encontraron preguntas: revisa el formato del HTML.',
  'Nobody has taken this check yet.': 'Nadie ha respondido estas preguntas todavía.',
  'Not passed yet': 'Aún no aprobado',
  'Not quite': 'No exactamente',
  'Not yet': 'Aún no',
  'One self-contained .html file, up to 5 MB': 'Un único archivo .html autocontenido, hasta 5 MB',
  'Open full size': 'Ver a tamaño completo',
  'Open it again': 'Abrirlo de nuevo',
  'Open the Wealth Baseline Scorecard': 'Abrir el Wealth Baseline Scorecard',
  'Open the form and answer honestly — your name, email and location come from your profile. When you submit, you will return here and this lesson will be marked complete.': 'Abre el formulario y responde con sinceridad: tu nombre, email y ubicación vienen de tu perfil. Al enviarlo volverás aquí y la lección quedará completada.',
  'Opening…': 'Abriendo…',
  'Pass the check to unlock the next lesson.': 'Aprueba las preguntas para desbloquear la siguiente lección.',
  'Pass the lesson': 'Aprueba las preguntas de la lección',
  'Passed': 'Aprobado',
  'Passing score': 'Nota para aprobar',
  'Paste code': 'Pegar código',
  'Pasted HTML': 'HTML pegado',
  'Pick the one correct answer per question': 'Marca la respuesta correcta de cada pregunta',
  'Preview': 'Vista previa',
  'Replace the current questions with the ones in the file?': '¿Reemplazar las preguntas actuales por las del archivo?',
  'Result saved to your progress': 'Resultado guardado en tu progreso',
  'Review answers': 'Revisar respuestas',
  'Review the lesson': 'Repasar la lección',
  'Review the lesson and retry — unlimited': 'Repasar y reintentar, sin límite',
  'Same format as the KMS Reading Quiz: one block per question, the right option marked with class="correct". The text “Why” is optional.': 'Mismo formato que el Reading Quiz del KMS: un bloque por pregunta y la opción correcta marcada con class="correct". El “Why” es opcional.',
  'Save lesson': 'Guardar lección',
  'Scorecard completed': 'Scorecard completado',
  'See results': 'Ver resultado',
  'See results for this lesson': 'Ver resultados de esta lección',
  'Take the check': 'Responder las preguntas',
  'The HTML file is larger than 5 MB': 'El archivo HTML pesa más de 5 MB',
  'This lesson opens the Wealth Baseline Scorecard form. The member fills it in (name, email and location come from their profile) and is returned to the course automatically; the lesson completes once they submit. No configuration needed.': 'Esta lección abre el formulario del Wealth Baseline Scorecard. El miembro lo completa (nombre, email y ubicación vienen de su perfil) y vuelve al curso automáticamente; la lección se completa al enviarlo. No requiere configuración.',
  'This lesson stays incomplete': 'La lección sigue sin completar',
  'Title is required': 'El título es obligatorio',
  'Try again': 'Intentar de nuevo',
  'Upload .html file': 'Subir archivo .html',
  'Upload or paste the HTML for this lesson': 'Sube o pega el HTML de esta lección',
  'Vimeo': 'Vimeo',
  'What should the HTML look like?': '¿Qué formato debe tener el HTML?',
  'Why': 'Por qué',
  'Why — shown after they answer': 'Por qué: se muestra tras responder',
  'Worth another look': 'Vale la pena repasarla',
  'Write the question': 'Escribe la pregunta',
  'You have completed your Wealth Baseline Scorecard. Continue to the next lesson.': 'Has completado tu Wealth Baseline Scorecard. Continúa con la siguiente lección.',
  'You need': 'Necesitas',
  'YouTube': 'YouTube',
  'Your answer': 'Tu respuesta',
  'Your answers': 'Tus respuestas',
  'and unlock lesson': 'y desbloquear la lección',
  'attempt': 'intento',
  'attempts': 'intentos',
  'check to unlock': 'para desbloquear',
  'correct': 'correctas',
  'correct answer': 'respuesta correcta',
  'correct so far': 'correctas hasta ahora',
  'interactive lesson': 'lección interactiva',
  'interactive lessons': 'lecciones interactivas',
  'is unlocked.': 'está desbloqueada.',
  'optional': 'opcional',
  'options': 'opciones',
  'pass with': 'apruebas con',
  'question': 'pregunta',
  'questions': 'preguntas',
  'questions loaded — review them and save the lesson.': 'preguntas cargadas: revísalas y guarda la lección.',
  'quick questions about this lesson.': 'preguntas rápidas sobre esta lección.',
  'right to complete it': 'para completarla',
  'stays locked': 'sigue bloqueada',
  'to complete this lesson. Go back over it, then try again — you can retry as many times as you need.': 'para completar esta lección. Repásala y vuelve a intentarlo: puedes reintentar las veces que necesites.',
  'your answer': 'tu respuesta',
  '“Mark complete” becomes “Take the check”. The student unlocks the next lesson only after passing.': '“Marcar como completada” pasa a ser “Responder las preguntas”. El alumno desbloquea la siguiente lección solo si aprueba.',
  // MMS_POINTS_HUB_PLAN F4 — Points tab
  "Points": "Puntos",
  "points": "puntos",
  "once each": "una vez cada uno",
  "up to": "hasta",
  "per day": "al día",
  "in total": "en total",
  "Points are not available right now. Try again in a moment.": "Los puntos no están disponibles ahora. Inténtalo en un momento.",
  "Earned in courses": "Ganados en cursos",
  "Total balance": "Saldo total",
  "Across every product, in My Account": "De todos los productos, en My Account",
  "Lessons completed": "Lecciones completadas",
  "courses completed": "cursos completados",
  "How to earn points here": "Cómo ganar puntos aquí",
  "Every action below adds points to your balance. Points are awarded a few seconds after the action.": "Cada acción de esta lista suma puntos a tu saldo. Los puntos llegan unos segundos después de la acción.",
  "No point actions are active in the LMS right now.": "Ahora mismo no hay acciones con puntos activas en el LMS.",
  "Action": "Acción",
  "Limits": "Límites",
  "Latest points": "Últimos puntos",
  "Complete your first lesson to earn your first points.": "Completa tu primera lección para ganar tus primeros puntos.",
  "Earn": "Gana",
  "points when you complete it": "puntos al completarlo",
  "Lesson completed": "Lección completada",
  "Course completed": "Curso completado",
  "Complete a lesson": "Completar una lección",
  "Pass a quiz (>=80%)": "Aprobar un quiz (≥80 %)",
  "Complete a course": "Completar un curso",
  "Start a course": "Empezar un curso",
  "Complete a module": "Completar un módulo",
  "Perfect quiz (100% first try)": "Quiz perfecto (100 % al primer intento)",
  "3-day study streak": "Racha de estudio de 3 días",
  "7-day study streak": "Racha de estudio de 7 días",
  "30-day study streak": "Racha de estudio de 30 días",
  "First course completed": "Primer curso completado",
  "5 courses completed": "5 cursos completados",
  "10 courses completed": "10 cursos completados",
  "Submit a lesson scorecard": "Enviar el scorecard de una lección",
  "Share a course": "Compartir un curso",
  "Rate a course": "Valorar un curso",
  "Write a course review": "Escribir una reseña del curso",
  "Ask the instructor": "Preguntar al instructor",
  "First visit to the LMS": "Primera visita al LMS",
  "Enroll in a course": "Inscribirse en un curso",
  "Buy a course (per US$ 1)": "Comprar un curso (por cada US$ 1)",
  "Times": "Veces",
  "per purchase": "por compra",
  // s155 course Students tab
  "View answers": "Ver respuestas",
  "Hide answers": "Ocultar respuestas",
  "Latest attempt": "Último intento",
  "Correct": "Correcta",
  "Incorrect": "Incorrecta",
  "Not answered": "Sin responder",
  "Their answer · correct": "Su respuesta · correcta",
  "Their answer": "Su respuesta",
  "View students": "Ver alumnos",
  "Attempted": "Intentó",
  "Back to students": "Volver a alumnos",
  "Check": "Check",
  "Could not load students": "No se pudieron cargar los alumnos",
  "Could not load this student": "No se pudo cargar este alumno",
  "Enrolled": "Inscrito",
  "Enrolled in": "Se inscribió en",
  "Evaluations": "Evaluaciones",
  "First opened": "Abierta por primera vez",
  "In progress": "En progreso",
  "Last activity": "Última actividad",
  "Membership": "Membresía",
  "No activity recorded yet.": "Aún no hay actividad registrada.",
  "No evaluation attempts yet.": "Aún no hay intentos de evaluación.",
  "No students in this course yet": "Este curso aún no tiene alumnos",
  "No students match these filters.": "Ningún alumno coincide con estos filtros.",
  "Not passed": "No aprobada",
  "Not released yet": "Aún no liberada",
  "Not started": "Sin empezar",
  "Now on": "Ahora en",
  "Opened": "Abrió",
  "Progress": "Progreso",
  "Quiz": "Quiz",
  "Recent activity": "Actividad reciente",
  "Search name or email…": "Buscar nombre o correo…",
  "State": "Estado",
  "Student": "Alumno",
  "When a member enrolls or their registration is approved, they will appear here with their progress.": "Cuando un miembro se inscriba o se apruebe su registro, aparecerá aquí con su progreso.",
  "a lesson": "una lección",
  "date not recorded": "fecha no registrada",
  "lessons": "lecciones",
  "on": "el",
  "passed": "aprobadas",
  "the comprehension check of": "el check de comprensión de",
  "the quiz of": "el quiz de",
  "visit": "visita",
  "visits": "visitas",
};

const LANG_KEY = 'lms_lang';

export function getLang() {
  return localStorage.getItem(LANG_KEY) === 'es' ? 'es' : 'en';
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang === 'es' ? 'es' : 'en');
  window.location.reload(); // simple + safe: strings are read at render time everywhere
}

export function t(key) {
  if (getLang() === 'es') return ES[key] || key;
  return key;
}
